export const en = "en";
export const es = "es";
export const ca = "ca";
export const continue_ = "continue";
export const new_ = "new";
export const formStateSession = "formState";
export const email_ = "email";
export const firebase = "firebase";
export const microsoft = "microsoft";

export const texts = {
  en: {
    login: "Log In",
    loginButton: "Log In",
    signin: "Sign In",
    signinMicrosoftButton: "Sign in with Microsoft",
    navbarWelcome: "Hi!",
    navbarChangeProfile: "Change profile",
    navbarLanguageTitle: "Change language to english",
    logout: "Logout",
    newQuiz: "Start quiz",
    continueQuiz: "Continue quiz",
    modalNewQuiz:
      "By restarting this quiz, you are going to delete previous answers. Are you sure to continue?",
    yes: "YES",
    no: "NO",
    selectOptionPlaceholder: "SELECT AN OPTION",
    save: "SAVE",
    cancel: "CANCEL",
    questionsGroupsTitle: "Questions Groups",
    questionGroupsSubtitle: "Indicate the closest answer",
    votingGroupsTitle: "Scenarios",
    votingGroupsSubtitle: "Indicates the most predominant scenario",
    questionGroupText: "Questions",
    votingGroupText: "Scenarios",
    scenariosQuestions: [
      "How should communication between the external professional and the insurance agent be during claim management?",
      "Incentive offers from competitors.",
      "Resource management.",
      "Influence on the type of work.",
      "Impact on collaboration and coordination.",
      "Perception of professional development opportunities.",
      "Use of infrastructure.",
      "Impact on brand recognition and customer trust.",
      "Impact of organizational culture on retention.",
      "Efficiency and regulatory compliance.",
      "Impact on professional conditions.",
      "What do you think is the impact of the external professional's level of interaction on the agent's reputation?",
      "Use of administrative and logistical support.",
      "Economic decisions and stability.",
      "Implementation of new technologies."
    ],
    formCompleted: "Form completed successfully",
    downloadResultsButtonText1: "Download IRT Report",
    downloadResultsButtonText2: "Download Draft AI",
    downloadResultsButtonText3: "Download Lite Innovation Lab",
    scenariosTitle: "SCENARIOS",
    scenariosSubtitle:
      "Select the option that best fits",
    saveQuestionGroupButton: "Save responses",
    saveVotingGroupButton: "Save responses",
    of: "of",
    responseNA: "N/A",
    start: "start",
    continue: "continue",
    selectQuestionsGroupTitleStart: "Select the group of questions or scenarios to",
    selectQuestionsGroupTitleContinue: "the quiz",
    questionsTitle: "QUESTIONS",
    questionsSubtitle: "Evaluate the statement according to the case",
    email: "Email",
    emailPlaceholder: "Your Email",
    password: "Password",
    passwordPlaceholder: "Your Password",
    emailError: "Unauthorized user domain",
    microsoftError: "Microsoft Auth Error",
    firebaseError: "Firebase Auth Error",
    HideMenuText: "Hide Menu",
    ShowMenuText: "Show Menu"
  },
  es: {
    login: "Iniciar sesión",
    loginButton: "Iniciar sesión",
    signin: "Registrarse",
    signinMicrosoftButton: "Registrarse con Microsoft",
    navbarWelcome: "¡Hola!",
    navbarChangeProfile: "Cambiar perfil",
    navbarLanguageTitle: "Cambiar idioma a inglés",
    logout: "Cerrar sesión",
    newQuiz: "Iniciar cuestionario",
    continueQuiz: "Continuar cuestionario",
    modalNewQuiz:
      "Al reiniciar este cuestionario, se eliminarán las respuestas anteriores. ¿Está seguro de continuar?",
    yes: "SÍ",
    no: "NO",
    selectOptionPlaceholder: "SELECCIONA UNA OPCIÓN",
    save: "GUARDAR",
    cancel: "CANCELAR",
    questionsGroupsTitle: "Grupos de preguntas",
    questionGroupsSubtitle: "Indica la respuesta más cercana",
    votingGroupsTitle: "Escenarios",
    votingGroupsSubtitle: "Indica el escenario más predominante",
    questionGroupText: "Preguntas",
    votingGroupText: "Escenarios",
    scenariosQuestions: [
              "¿Cómo considera que debería ser la comunicación entre el profesional externo y el agente de seguros durante la gestión del siniestro?",
              "Oferta de Incentivos por parte de la Competencia.",
              "Gestión de Recursos.",
              "Influencia en el tipo de trabajo. ",
              "Impacto en la Colaboración y Coordinación.",
              "Percepción de Oportunidades de Desarrollo Profesional.",
              "Uso de Infraestructura.",
              "Impacto en el Reconocimiento de Marca y la Confianza del Cliente.",
              "Impacto de la Cultura Organizacional en la Retención.",
              "Eficiencia y Cumplimiento Normativo.",
              "Impacto en las condiciones profesionales.",
              "¿Cuál cree que es el impacto del nivel de interacción del profesional externo en la reputación del agente?",
              "Uso del Soporte Administrativo y Logístico.",
              "Decisiones económicas y estabilidad.",
              "Implementación de Nuevas Tecnologías."
            ],
    formCompleted: "Formulario completado con éxito",
    downloadResultsButtonText1: "Descargar informe IRT",
    downloadResultsButtonText2: "Descargar borrador IA",
    downloadResultsButtonText3: "Descargar Lite Innovation Lab",
    scenariosTitle: "ESCENARIOS",
    scenariosSubtitle:
      "Selecciona la opción que mejor se ajuste",
    saveQuestionGroupButton: "Guardar respuestas",
    saveVotingGroupButton: "Guardar respuestas",
    of: "de",
    responseNA: "N/D",
    start: "iniciar",
    continue: "continuar",
    selectQuestionsGroupTitleStart: "Selecciona el grupo de preguntas o escenarios para",
    selectQuestionsGroupTitleContinue: "el cuestionario",
    questionsTitle: "PREGUNTAS",
    questionsSubtitle: "Evalúa la afirmación según el caso",
    email: "Correo electrónico",
    emailPlaceholder: "Tu correo electrónico",
    password: "Contraseña",
    passwordPlaceholder: "Tu contraseña",
    emailError: "Dominio de usuario no autorizado",
    microsoftError: "Error de autenticación de Microsoft",
    firebaseError: "Error de autenticación de Firebase",
    HideMenuText: "Ocultar menú",  
    ShowMenuText: "Mostrar menú"
  }
  ,
  ca: {
    login: "Iniciar sessió",
    loginButton: "Entrar",
    signin: "Iniciar sessió",
    signinMicrosoftButton: "Entrar amb Microsoft",
    navbarWelcome: "Hola!",
    navbarChangeProfile: "Canviar perfil",
    navbarLanguageTitle: "Canviar idioma a català",
    logout: "Tancar sessió",
    newQuiz: "Començar qüestionari",
    continueQuiz: "Continuar qüestionari",
    modalNewQuiz: "En reiniciar aquest qüestionari, s'eliminaran les respostes anteriors. Estàs segur de voler continuar?",
    yes: "SÍ",
    no: "NO",
    selectOptionPlaceholder: "SELECCIONA UNA OPCIÓ",
    save: "DESAR",
    cancel: "CANCEL·LAR",
    questionsGroupsTitle: "Grups de preguntes",
    questionGroupsSubtitle: "Indica la resposta més propera",
    votingGroupsTitle: "Escenaris",
    votingGroupsSubtitle: "Indica l'escenari més predominant",
    questionGroupText: "Preguntes",
    votingGroupText: "Escenaris",
    scenariosQuestions: [
      "Com considera que hauria de ser la comunicació entre el professional extern i l’agent d’assegurances durant la gestió del sinistre?",
      "Oferta d’incentius per part de la competència.",
      "Gestió de recursos.",
      "Influència en el tipus de treball.",
      "Impacte en la col·laboració i coordinació.",
      "Percepció de les oportunitats de desenvolupament professional.",
      "Ús de la infraestructura.",
      "Impacte en el reconeixement de marca i la confiança del client.",
      "Impacte de la cultura organitzativa en la retenció.",
      "Eficiència i compliment normatiu.",
      "Impacte en les condicions professionals.",
      "Quin creu que és l’impacte del nivell d’interacció del professional extern en la reputació de l’agent?",
      "Ús del suport administratiu i logístic.",
      "Decisions econòmiques i estabilitat.",
      "Implementació de noves tecnologies."
    ],
    formCompleted: "Formulari completat amb èxit",
    downloadResultsButtonText1: "Descarregar Informe IRT",
    downloadResultsButtonText2: "Descarregar Draft AI",
    downloadResultsButtonText3: "Descarregar Lite Innovation Lab",
    scenariosTitle: "ESCENARIS",
    scenariosSubtitle: "Selecciona l’opció que millor s’ajusti",
    saveQuestionGroupButton: "Desa les respostes",
    saveVotingGroupButton: "Desa les respostes",
    responseNA: "N/C",
    of: "de",
    start: "iniciar",
    continue: "continuar",
    selectQuestionsGroupTitleStart: "Selecciona el grup de preguntes o escenaris per",
    selectQuestionsGroupTitleContinue: "el qüestionari",
    questionsTitle: "PREGUNTES",
    questionsSubtitle: "Avaluar l'afirmació segons el cas",
    email: "Correu electrònic",
    emailPlaceholder: "El teu correu electrònic",
    password: "Contrasenya",
    passwordPlaceholder: "La teva contrasenya",
    emailError: "Dominio d'usuari no autoritzat",
    microsoftError: "Error d'autenticació de Microsoft",
    firebaseError: "Error d'autenticació de Firebase",
    HideMenuText: "Amaga el menú",  
    ShowMenuText: "Mostra el menú"
  },
};
